import React, { useRef } from 'react';
import classNames from 'classnames';
import { useForkRef } from '../../hooks/useForkRef';
import { omitKeys } from '../../utils/object';
import { STICKY_OPTIONS_KEYS, getStickyContainerStyle, getStickyChildStyle, } from './stickyEmulation';
import { useSticky } from './useSticky';
export function Sticky(props) {
    const { containerClassName, containerStyle, containerRef, forwardRef, style, initialState, ...restProps } = omitKeys(props, STICKY_OPTIONS_KEYS);
    const containerStickyRef = useRef(null);
    const containerForkRef = useForkRef(containerRef, containerStickyRef);
    const childStickyRef = useRef(null);
    const childForkRef = useForkRef(forwardRef, childStickyRef);
    const stickyState = useSticky(props, containerStickyRef, childStickyRef, initialState);
    return (React.createElement("div", { className: classNames('sticky-container', containerClassName), style: {
            ...getStickyContainerStyle(stickyState, props),
            ...containerStyle || {},
        }, ref: containerForkRef },
        React.createElement("div", Object.assign({}, restProps, { style: {
                ...getStickyChildStyle(stickyState, props),
                ...style || {},
            }, ref: childForkRef }))));
}
//# sourceMappingURL=Sticky.js.map